import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePayOnBehalfRequestsInput,
    PayOnBehalfRequests,
    UpdatePayOnBehalfRequestsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PayOnBehalfRequestsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPayOnBehalfRequests(): Promise<PayOnBehalfRequests[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPayOnBehalfRequests
                })
            ).data.listPayOnBehalfRequests.items;
            if (data) return data as PayOnBehalfRequests[];
        } catch (error) {
            console.error('Error finding PayOnBehalfRequests:', error);
            return null;
        }
    }

    async listAllPayOnBehalfRequests(
        pageLimit: number = 20
    ): Promise<PayOnBehalfRequests[]> {
        const payOnBehalfRequests: PayOnBehalfRequests[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listPayOnBehalfRequests,
                        variables: {
                            nextToken,
                            limit: pageLimit
                        }
                    })
                ).data.listPayOnBehalfRequests;

                if (response?.items) {
                    payOnBehalfRequests.push(
                        ...(response.items as PayOnBehalfRequests[])
                    );
                }
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return payOnBehalfRequests;
        } catch (error) {
            console.error('Error finding PayOnBehalfRequests:', error);
            return [];
        }
    }

    async createPayOnBehalfRequests(
        input: CreatePayOnBehalfRequestsInput
    ): Promise<PayOnBehalfRequests> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPayOnBehalfRequests,
                    variables: {
                        input
                    }
                })
            ).data.createPayOnBehalfRequests;
            if (data) return data as PayOnBehalfRequests;
        } catch (error) {
            console.error('Error creating PayOnBehalfRequests:', error);
            return null;
        }
    }
    async updatePayOnBehalfRequest(
        input: UpdatePayOnBehalfRequestsInput
    ): Promise<PayOnBehalfRequests> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePayOnBehalfRequests,
                    variables: {
                        input
                    }
                })
            ).data.updatePayOnBehalfRequests;
            if (data) return data as PayOnBehalfRequests;
        } catch (error) {
            console.error('Error creating PayOnBehalfRequests:', error);
            return null;
        }
    }
}
